import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../commons/Auth';
import { useLoading } from '../../commons/Loading';
import { useAlert } from 'react-alert';
import classnames from 'classnames';
import {
  BtnModalTable,
  BtnOutlineGreen,
  BtnOutlineRed,
  H4Styled,
  H5Styled,
} from '../../styled-components';
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap';
import axios from 'axios';
import { createBonus } from '../../lib/fetch/reports';
import moment from 'moment';
import InsuranceTabel from './InsuranceTabel';

const ModalIafs = ({
  data = [],
  month,
  value,
  year,
  fetchPanoramicaInvoicesByMonth,
}) => {
  const [t] = useTranslation('ROYALTY');
  const [{ newToken, profile = {} } = {}] = useAuth();
  const alert = useAlert();
  const { showLoading, hideLoading } = useLoading();

  const [modal, setModal] = useState(false);
  const [dataForIafsInsurances, setDataForIafsInsurances] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [totIafs, setTotIafs] = useState(0);
  const [totInsurances, setTotInsurances] = useState(0);
  const [sentinel, setSentinel] = useState('insurances');

  const toggle = () => {
    setModal(!modal);
  };

  const CURRENT_YEAR = new Date().getFullYear();
  const CURRENT_MONTH = new Date().getMonth() + 1;

  const getColor = ({ month, totalCount, year }) => {
    const notNull = totalCount !== null;
    if (notNull || year > CURRENT_YEAR) return '';

    if (year < CURRENT_YEAR) return notNull ? '' : 'red';
    if (month < CURRENT_MONTH) return notNull ? '' : 'red';
    return '';
  };

  const confirmPreview = async (bonus) => {
    const { error } = await createBonus({
      newToken,
      bonus: { ...bonus, profileId: data.profileId },
    });

    if (error) {
      alert.error(t('COMMON:GENERIC_ERROR'));
      return;
    }
  };

  const handleConfirm = async () => {
    try {
      showLoading();

      if (dataForIafsInsurances.length > 0) {
        console.log("=================");
        console.log("dataForIafsInsurances:", dataForIafsInsurances);
        console.log("=================");

        await confirmPreview({
          iafType: 'INSURANCES',
          amount: totInsurances,
          date: moment.utc().startOf('day').format(),
          accountability: year,
          insurances: dataForIafsInsurances.map(
            ({
              _id,
              branch,
              policy_code,
              insurance_code,
              start_date,
              end_date,
              gross,
              net,
              shareToInvoice,
              shareToInvoicePerc,
              subAgencyPerc,
              panoramicaShare,
              adminShare,
              customerId,
              admin,
              earnedCommercialShare,
              commercialShare,
              agencyType,
            }) => ({
              _id,
              branch,
              policy_code,
              insurance_code,
              start_date,
              end_date,
              gross,
              net,
              shareToInvoice,
              shareToInvoicePerc,
              subAgencyPerc,
              panoramicaShare,
              adminShare,
              customerId,
              admin,
              earnedCommercialShare,
              commercialShare,
              agencyType,
            })
          ),
        });
      }

      setDataForIafsInsurances([]);
      toggle();
      await fetchPanoramicaInvoicesByMonth(true);

      alert.success(t('COMMON:SUCCESS_UPDATE'));
    } catch (error) {
      alert.error(t('COMMON:GENERIC_ERROR'));
    } finally {
      hideLoading();
    }
  };

  useEffect(() => {
    const count = data.insurances[month - 1]?.count || 0;
    setTotalCount(count);
    setDataForIafsInsurances(data.insurances[month - 1]?.insurances || []);

    const insurances = data.insurances[month - 1]?.insurances || [];

    const sum = [...insurances].reduce(
      (acc, item) => acc + (item.adminShare || 0),
      0
    );
    const sumInsurances = insurances.reduce(
      (acc, item) => acc + (item.adminShare || 0),
      0
    );

    setTotIafs(sum.toFixed(2));
    setTotInsurances(sumInsurances.toFixed(2));
  }, [data]);

  return (
    <>
      <span
        style={{
          color: getColor({ month, totalCount, year }),
          cursor: 'pointer',
        }}
      >
        <span>Elementi da emettere: {totalCount || 0}</span>
        <br />
        <span>Totale: € {totIafs}</span>
        <br />
        <br />
        <span>Totale assicurazioni: € {totInsurances}</span>
        <br />

        <br />
        {totalCount > 0 && (
          <div className="flex-check">
            <BtnModalTable
              type="button"
              onClick={(event) => {
                event.stopPropagation();
                toggle();
              }}
            >
              Emetti IAF
            </BtnModalTable>
          </div>
        )}
      </span>

      <Modal isOpen={modal} className="iafs-modal">
        <ModalHeader toggle={toggle}>
          Anteprima IAF
          <br />
        </ModalHeader>
        <ModalBody>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <h5 style={{ fontFamily: "'Open Sans', sans-serif" }}>
              Totale da emettere: € {totIafs}
            </h5>
            <h5 style={{ fontFamily: "'Open Sans', sans-serif" }}>
              Elementi da emettere: {totalCount}
            </h5>
          </div>

          <Nav tabs>
            <NavItem>
              <NavLink
                className={classnames({ active: sentinel === 'insurances' })}
                onClick={() => setSentinel('insurances')}
                style={{ cursor: 'pointer' }}
              >
                Assicurazioni
              </NavLink>
            </NavItem>
          </Nav>

          {sentinel === 'insurances' && dataForIafsInsurances?.length > 0 && (
            <div style={{ marginTop: '10px' }}>
              <InsuranceTabel
                data={dataForIafsInsurances}
                onFilter={() => {}}
                query={{
                  limit: dataForIafsInsurances?.length || 50,
                  offset: 0,
                }}
                total={dataForIafsInsurances?.length}
              />
            </div>
          )}

          {sentinel === 'insurances' && dataForIafsInsurances?.length === 0 && (
            <H4Styled style={{ textAlign: 'center', marginTop: '15px' }}>
              Non ci sono assicurazioni su cui emettere iaf
            </H4Styled>
          )}
        </ModalBody>
        <ModalFooter>
          <BtnOutlineRed type="button" className="uppercase" onClick={toggle}>
            {t('COMMON:CANCEL')}
          </BtnOutlineRed>
          {totalCount > 0 && (
            <BtnOutlineGreen
              type="button"
              className="uppercase"
              onClick={handleConfirm}
            >
              Conferma IAF
            </BtnOutlineGreen>
          )}
        </ModalFooter>
      </Modal>
    </>
  );
};

export default ModalIafs;
